"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var SvgIcon_1 = require("./internal/SvgIcon");

exports.Shipment = function (props) {
  return react_1.default.createElement(SvgIcon_1.SvgIcon, tslib_1.__assign({}, props), react_1.default.createElement("svg", {
    viewBox: "0 0 16 16"
  }, react_1.default.createElement("g", {
    clipPath: "url(#clip0)"
  }, react_1.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.99707 12.002C6.29785 12.002 6.53939 11.9108 6.72168 11.7285C6.90397 11.5462 6.9974 11.3024 7.00195 10.9971C7.00195 10.6963 6.91081 10.4548 6.72852 10.2725C6.54622 10.0902 6.30241 9.99902 5.99707 9.99902C5.69629 9.99902 5.45475 10.0902 5.27246 10.2725C5.09017 10.4548 4.99902 10.6963 4.99902 10.9971C4.99902 11.3024 5.09017 11.5462 5.27246 11.7285C5.45475 11.9108 5.69629 12.002 5.99707 12.002ZM8 10.9971C8 11.5485 7.80404 12.0202 7.41211 12.4121C7.02018 12.804 6.54851 13 5.99707 13C5.44564 13 4.97396 12.804 4.58203 12.4121C4.1901 12.0202 3.99642 11.5485 4.00098 10.9971C4.00098 10.9196 4.00553 10.8604 4.01465 10.8193L1 8.09863L2.10059 6.7998L4.86914 9.34961C5.20638 9.11719 5.59147 9.00098 6.02441 9.00098C6.45736 9.00098 6.84472 9.12858 7.18652 9.38379C8.01595 8.44498 9.04361 7.23275 10.2695 5.74707C11.5 4.26139 12.3773 3.17904 12.9014 2.5C13.0518 2.34505 13.2546 2.25391 13.5098 2.22656C13.765 2.19922 13.9951 2.25618 14.2002 2.39746L16.1006 4.09961L15.1982 5.2002L13.7012 3.90137L7.98633 10.7646C7.99544 10.8193 8 10.8968 8 10.9971ZM5.99707 8.7002L2.40137 5.39844L6.20215 1.00293L9.79785 4.20215L5.99707 8.7002Z",
    clipRule: "evenodd"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: "clip0"
  }, react_1.default.createElement("rect", {
    width: 16,
    height: 16
  })))));
};